import React from 'react';

import { ApplicationContent } from '../../layout/ApplicationContent/ApplicationContent';
import ApplicationHeader from '../../ApplicationHeader/ApplicationHeader';

interface NotAuthenticatedProps {
  loginUrl?: string;
}

const NotAuthenticated = (props: NotAuthenticatedProps) => {
  React.useEffect(() => {
    const timer = setTimeout(() => {
      if (props.loginUrl) window.location.href = props.loginUrl;
    }, 5000);
    return () => clearTimeout(timer);
  }, [props.loginUrl]);

  return (
    <div>
      <ApplicationHeader />
      <ApplicationContent />
    </div>
  );
};

export default NotAuthenticated;
